module.exports = __webpack_public_path__ + "static/img/consult.44c7298f.png";